import { useCurrency } from '@/hooks/useCurrency'
import { DataTable, ReportPage, StatGrid, useReport, exportCsv, type Column } from '@/components/reports/ReportKit'

interface TableRow {
  table: string
  area: string
  bills: number
  revenue: number
  avgBill: number
}
interface AreaRow {
  area: string
  bills: number
  revenue: number
  avgBill: number
}
interface TableData {
  tables: TableRow[]
  areas: AreaRow[]
  summary: { tableCount: number; mostUsed: string; leastUsed: string; topArea: string }
}

export default function TablePerformanceScreen() {
  const { formatCurrency } = useCurrency()
  const report = useReport<TableData>('table-performance')
  const data = report.data

  const tableColumns: Column<TableRow>[] = [
    { key: 'table', header: 'Table', render: r => <span className="font-medium">{r.table}</span> },
    { key: 'area', header: 'Area' },
    { key: 'bills', header: 'Bills', align: 'right' },
    { key: 'revenue', header: 'Revenue', align: 'right', render: r => formatCurrency(r.revenue) },
    { key: 'avgBill', header: 'Avg bill', align: 'right', render: r => formatCurrency(r.avgBill) }
  ]
  const areaColumns: Column<AreaRow>[] = [
    { key: 'area', header: 'Area', render: r => <span className="font-medium">{r.area}</span> },
    { key: 'bills', header: 'Bills', align: 'right' },
    { key: 'revenue', header: 'Revenue', align: 'right', render: r => formatCurrency(r.revenue) },
    { key: 'avgBill', header: 'Avg bill', align: 'right', render: r => formatCurrency(r.avgBill) }
  ]

  return (
    <ReportPage
      eyebrow="Floor · Utilisation"
      title="Table & Area Performance"
      subtitle="Revenue per table and area, and which tables are used most and least"
      report={report}
      onExport={() => exportCsv('table-performance', tableColumns, data?.tables ?? [])}
    >
      {data && (
        <>
          <StatGrid
            stats={[
              { label: 'Tables used', value: data.summary.tableCount },
              { label: 'Top area', value: data.summary.topArea },
              { label: 'Most used table', value: data.summary.mostUsed },
              { label: 'Least used table', value: data.summary.leastUsed }
            ]}
          />
          <DataTable title="By area" columns={areaColumns} rows={data.areas} rowKey={r => r.area} defaultSort="revenue" empty="No sales in this period." />
          <DataTable title="By table" columns={tableColumns} rows={data.tables} rowKey={r => r.table} defaultSort="revenue" csvName="table-performance" empty="No sales in this period." />
        </>
      )}
    </ReportPage>
  )
}
